// extracted by mini-css-extract-plugin
export default {"gaps":"buttonGroup_gaps__bMmtD"};